/** Saved to DB on create when not changed; used by certificateGenerator. */
export const CERT_TEMPLATE_DEFAULTS = {
  name_font_family: "times-new-roman",
  name_italic: false,
  date_align: "center",
};

export const CERT_NAME_FONT_FAMILIES = [
  { id: "times-new-roman", label: "Times New Roman" },
  { id: "sans-serif", label: "Sans Serif" },
  { id: "calibri", label: "Calibri" },
  { id: "roboto", label: "Roboto" },
  { id: "lato", label: "Lato" },
  { id: "calligraphy", label: "Calligraphy" },
  { id: "handwriting", label: "Handwriting" },
];

/** Legacy ids from earlier templates — mapped when loading/saving. */
export const CERT_NAME_FONT_LEGACY_MAP = {
  serif: "times-new-roman",
  sans: "sans-serif",
  georgia: "times-new-roman",
  script: "calligraphy",
};

export const CERT_NAME_FONT_CSS = {
  "times-new-roman": '"Times New Roman", Times, serif',
  "sans-serif": 'Arial, "Helvetica Neue", Helvetica, sans-serif',
  calibri: 'Calibri, "Segoe UI", Candara, sans-serif',
  roboto: "Roboto, sans-serif",
  lato: "Lato, sans-serif",
  calligraphy: '"Palace Script MT", "Segoe Script", "Brush Script MT", cursive',
  handwriting: '"Segoe Print", "Comic Sans MS", "Bradley Hand", cursive',
};

export const CERT_DATE_ALIGNMENTS = [
  { id: "left", label: "Left" },
  { id: "center", label: "Center" },
  { id: "right", label: "Right" },
];

/** Shown in admin preview only — real name is passed when generating certificates. */
export const CERT_PREVIEW_SAMPLE_NAME = "Recipient Name";

export function normalizeFontFamilyId(fontId) {
  const id = String(fontId ?? "").trim().toLowerCase();
  if (CERT_NAME_FONT_CSS[id]) return id;
  if (CERT_NAME_FONT_LEGACY_MAP[id]) return CERT_NAME_FONT_LEGACY_MAP[id];
  return CERT_TEMPLATE_DEFAULTS.name_font_family;
}

export function resolveNameFontFamily(fontId) {
  return CERT_NAME_FONT_CSS[normalizeFontFamilyId(fontId)] || CERT_NAME_FONT_CSS["times-new-roman"];
}

/** Scale display name font size down as the name grows longer. */
export function computeRecipientNameFontSize(name, { basePx = 3.25, minPx = 1.5 } = {}) {
  const len = String(name ?? "").trim().length;
  if (len <= 10) return `${basePx}rem`;
  if (len <= 18) return `${basePx * 0.82}rem`;
  if (len <= 28) return `${basePx * 0.65}rem`;
  if (len <= 40) return `${basePx * 0.52}rem`;
  return `${minPx}rem`;
}

export function formatCertificateDate(date = new Date()) {
  return date.toLocaleDateString("en-IN", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}
